const blog1    = require('./blog_image.png');
const chat     = require('./chat.png');
const calander = require('./calendar.png');
const profile  = require('./user.png');
const tag      = require('./tag.png') 

export {
    blog1,chat,calander ,profile ,tag
}